export default {"src":"/_next/static/media/shield-hero.7813bc89.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};